import React from 'react';
import { useTranslation } from 'react-i18next';
import { SubscriptionPlan } from './subscription-plan.component';

interface IProps {
  refScroll: React.RefObject<HTMLDivElement>;
  title?: string;
  subtitle?: string;
}

export const SubscriptionsPlans = ({ refScroll, title, subtitle }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className="mt-[44px]">
      {(title || subtitle) && (
        <div className="mb-[20px]" ref={refScroll}>
          {title && (
            <h2 className="font-display font-bold text-[20px] tracking-[-0.015em] text-content-dark">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="font-body text-[13.5px] text-content-muted-alt mt-[4px]">
              {subtitle}
            </p>
          )}
        </div>
      )}
      {/* Prices carry their own "$". The card renders customPrice VERBATIM -
          it used to add the prefix itself, but only in checkout mode, so the
          same string showed as "$15" on one card and "$$15" on another. When
          that was fixed these three were left bare and quietly lost their
          symbol. A price with no currency on it is the kind of thing nobody
          reports and everybody notices. */}
      <div
        id="subscription-plans"
        className="grid grid-cols-1 md:grid-cols-3 gap-[14px] items-stretch"
      >
        <SubscriptionPlan
          caption={t('subscription.freeTrialCaption')}
          customPrice="$0"
          duration={t('subscription.freeTrialDuration')}
          plan="free"
          key={1}
          description={t('subscription.freeTrialDescription')}
          statValue={t('subscription.freeTrialStatValue')}
          statLabel={t('subscription.freeTrialStatLabel')}
          buttonText={t('subscription.startFreeTrial')}
        />
        <SubscriptionPlan
          caption={t('subscription.monthlyCaption')}
          customPrice="$10"
          duration={t('subscription.monthlyDuration')}
          plan="1m"
          key={2}
          description={t('subscription.monthlyDescription')}
          statValue={t('subscription.monthlyStatValue')}
          statLabel={t('subscription.monthlyStatLabel')}
          buttonText={t('subscription.buyMonthly')}
        />
        <SubscriptionPlan
          caption={t('subscription.annualCaption')}
          customPrice="$100"
          duration={t('subscription.annualDuration')}
          plan="1y"
          key={3}
          badgeText={t('subscription.annualBadge')}
          description={t('subscription.annualDescription')}
          statValue={t('subscription.annualStatValue')}
          statLabel={t('subscription.annualStatLabel')}
          buttonText={t('subscription.buyAnnual')}
          isPopular
        />
      </div>
    </div>
  );
};
